import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'page.notificationSettings.title',
    defaultMessage: 'Notification Domains',
  },
  scopeAlert: {
    id: 'page.notificationSettings.scopeAlert',
    defaultMessage: 'This setting applies to all users administered under this account.',
  },
  sectionDescription: {
    id: 'page.notificationSettings.sectionDescription',
    defaultMessage:
      'These settings apply to every email notification sent from your account, including ones generated by AI Agents, Shares created by users in the dashboard, and any API call that triggers a notification to an external address. Notifications can always be delivered to you and members of your account; add external email domains here (e.g. client.com, partner.io) to allow delivery outside your account, or turn on "Allow all external domains" to disable the restriction.',
  },
  emptyHint: {
    id: 'page.notificationSettings.emptyHint',
    defaultMessage:
      'No external domains allowed yet. Notifications are restricted to members of your account.',
  },
  allowAllLabel: {
    id: 'page.notificationSettings.allowAllLabel',
    defaultMessage: 'Allow all external domains',
  },
  allowAllHint: {
    id: 'page.notificationSettings.allowAllHint',
    defaultMessage:
      "Anyone with automation access can email any external address from your account. Turn this off to restrict to the listed domains.",
  },
  allowAllWarning: {
    id: 'page.notificationSettings.allowAllWarning',
    defaultMessage: 'Any external recipient can receive email from your account.',
  },
  domainsLabel: {
    id: 'page.notificationSettings.domainsLabel',
    defaultMessage: 'Allowed domains',
  },
  domainsDisabledHint: {
    id: 'page.notificationSettings.domainsDisabledHint',
    defaultMessage: "Disabled while 'Allow all external domains' is on.",
  },
  save: {
    id: 'page.notificationSettings.save',
    defaultMessage: 'Save',
  },
  saving: {
    id: 'page.notificationSettings.saving',
    defaultMessage: 'Saving...',
  },
  discard: {
    id: 'page.notificationSettings.discard',
    defaultMessage: 'Discard',
  },
  loadError: {
    id: 'page.notificationSettings.loadError',
    defaultMessage: 'Failed to load notification settings.',
  },
  retry: {
    id: 'page.notificationSettings.retry',
    defaultMessage: 'Retry',
  },
  savedToast: {
    id: 'page.notificationSettings.savedToast',
    defaultMessage: 'Notification domains updated',
  },
  saveError: {
    id: 'page.notificationSettings.saveError',
    defaultMessage: 'Failed to update notification settings.',
  },
});
